// FE-SCRM-020 — Producer-friendly labels for backend chip codes.
//
// Backend ships stable strings (``renewal_window_approaching``,
// ``large_group``, etc.); this map turns each into the human-readable
// chip the SPA renders. Keep the strings benefits-broker-flavoured
// — avoid raw Form 5500 jargon ("welfare benefit code", "ACK_ID")
// in primary copy per spec §FE-SCRM-020.

export const FIT_REASON_LABELS: Record<string, string> = {
  renewal_window_approaching: "Renewal approaching",
  large_group: "Large group",
  multi_plan_complexity: "Multi-plan footprint",
  compliance_heavy_footprint: "Compliance-heavy",
  possible_displacement_target: "Single-carrier displacement",
  growing_organization: "Growing team",
  compliance_risk_signal: "Compliance risk",
  provider_compensation_visibility: "Compensation visible",
};

export function labelForFitReason(code: string): string {
  return FIT_REASON_LABELS[code] ?? code;
}

export const ALERT_TYPE_LABELS: Record<string, string> = {
  participants_increased: "Headcount growth",
  participants_decreased: "Headcount decline",
  carrier_changed: "Carrier change",
  carrier_added: "New carrier added",
  carrier_removed: "Carrier dropped",
  new_plan_filed: "New plan filed",
  plan_dropped: "Plan dropped",
  late_filing: "Filed late",
  filing_recovered: "Filing recovered",
  provider_changed: "Service-provider change",
  compensation_changed: "Compensation change",
};

export function labelForAlertType(code: string): string {
  return ALERT_TYPE_LABELS[code] ?? code;
}
